import TextField from "@mui/material/TextField"

import Row from "../../../../../../common/components/Row"
import { getEditorData } from "../../utils"
import EditorDrawer, { useEditorDrawerState } from "../EditorDrawer"
import TimeDelayNodeData from "./TimeDelayNodeData"

export default function TimeDelayNodeEditor({ open, onClose, node }) {
  const {
    newFieldState,
    setNewFieldState,
    tileChanged,
    saveState,
    revertState,
  } = useEditorDrawerState(getEditorData(node) || new TimeDelayNodeData())

  function updateField(fieldName) {
    return (e) => {
      setNewFieldState({ ...newFieldState, [fieldName]: e.target.value })
    }
  }

  return (
    <EditorDrawer
      open={open}
      onClose={onClose}
      node={node}
      editorState={newFieldState}
      tileChanged={tileChanged}
      onChangesSaved={saveState}
      onChangesDiscarded={revertState}
      title="Time Delay"
    >
      <Row
        sx={{
          px: 3,
          mt: 2,
          "& .MuiTextField-root:nth-of-type(n + 2)": { ml: 1 },
        }}
      >
        <TextField
          label="Days"
          value={newFieldState.days}
          onChange={updateField("days")}
          type="number"
        />
        <TextField
          label="Hours"
          value={newFieldState.hours}
          onChange={updateField("hours")}
          type="number"
        />
        <TextField
          label="Minutes"
          value={newFieldState.minutes}
          onChange={updateField("minutes")}
          type="number"
        />
      </Row>
    </EditorDrawer>
  )
}
